import { render, staticRenderFns } from "./ReserveLimit.vue?vue&type=template&id=4690d5ac"
import script from "./ReserveLimit.vue?vue&type=script&lang=js"
export * from "./ReserveLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports